import packageJson from '../../package.json';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t border-gray-100 bg-gray-50 mt-8">
      <div className="max-w-[3200px] mx-auto px-2 sm:px-4 lg:px-4 xl:px-6 2xl:px-8 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <div className="flex items-center gap-2">
            <span>© {currentYear} Philips Family Album</span>
            <span className="hidden sm:inline">•</span>
            <span className="px-2 py-0.5 bg-gray-200 rounded text-gray-700 font-mono">
              v{packageJson.version}
            </span>
          </div>
          
          <div className="flex items-center gap-3">
            <a
              href="/about"
              className="hover:text-gray-900 transition-colors"
            >
              About
            </a>
            <span>•</span>
            <span className="text-gray-400">
              Built with ❤️ by Jay Coleman for the Phillips (and extended) family
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

